// extracted by mini-css-extract-plugin
module.exports = {"tooltipText":"TruncatedText_tooltipText__3PPVZ","text":"TruncatedText_text__1Ww0x"};